import { SaveIcon } from "lucide-react";

import { Button, type ButtonSize } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";
import { SHORTCUTS } from "@/utils/shortcuts";

interface SaveButtonProps {
  label: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  isSaving?: boolean;
  hasUnsavedChanges?: boolean;
  size?: ButtonSize;
  tooltipContent?: string;
  className?: string;
}

const SaveButton = ({
  label,
  onClick,
  disabled = false,
  isSaving = false,
  hasUnsavedChanges = false,
  size = "default",
  tooltipContent,
  className,
}: SaveButtonProps) => {
  const button = (
    <Button
      variant="outline"
      size={size}
      className={cn(
        "whitespace-nowrap transition-all duration-200 hover:bg-gray-50 active:scale-95",
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="relative flex items-center">
        <SaveIcon className="mr-2 h-4 w-4 text-gray-600" />
        {hasUnsavedChanges && (
          <div className="absolute -top-1 right-0.5 h-2 w-2 animate-pulse rounded-full bg-yellow-400 shadow-sm" />
        )}
      </div>
      <span className="flex items-center gap-2">
        <span>{isSaving ? "Saving..." : label}</span>
        <span className="select-none opacity-60 transition-opacity duration-200 ease-in-out">
          {SHORTCUTS.SAVE.display}
        </span>
      </span>
    </Button>
  );

  if (tooltipContent) {
    return (
      <BasicTooltip content={tooltipContent}>
        <span>{button}</span>
      </BasicTooltip>
    );
  }

  return button;
};

export default SaveButton;
